import React from 'react'
import { Link } from 'react-router-dom'
// import style from "./finder.modules.css";

export default function FindCoder() {
  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-primary-subtle">

        <div className="container-fluid border">
          <svg width="38" height="22" viewBox="0 0 38 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.356678 11.4956C-0.118893 11.2104 -0.118892 10.4976 0.356679 10.2125L14.7197 1.60122C15.4408 1.16889 16.1693 2.15119 15.5826 2.76473L8.34608 10.3321C8.06984 10.6209 8.06984 11.0871 8.34608 11.376L15.5826 18.9433C16.1693 19.5569 15.4408 20.5392 14.7197 20.1068L0.356678 11.4956Z" fill="#2D88E2">
            </path><path class="fill-black dark:fill-white" d="M8.51066 1.55168C8.23967 1.27027 8.23967 0.824966 8.51066 0.543559C8.7965 0.246733 9.2717 0.246733 9.55753 0.543559L28.7255 20.4483C28.9964 20.7297 28.9964 21.175 28.7255 21.4564C28.4396 21.7533 27.9644 21.7533 27.6786 21.4564L8.51066 1.55168Z"></path>
            <path d="M37.6433 10.2125C38.1189 10.4976 38.1189 11.2104 37.6433 11.4956L23.2803 20.1068C22.5592 20.5392 21.8307 19.5569 22.4174 18.9433L29.6539 11.376C29.9302 11.0871 29.9302 10.6209 29.6539 10.332L22.4174 2.76473C21.8307 2.15118 22.5592 1.16888 23.2803 1.60122L37.6433 10.2125Z" fill="#2D88E2"  ></path></svg>
          <Link to='/' className="navbar-brand"  style={{ fontSize: "26px", color: "rgb(45 136 226)", fontfamily: "Poppins,sans-serif", marginLeft: "15px" }}>FindCoder</Link>

          <div className="collapse navbar-collapse" style={{ marginLeft: "400px", fontSize:"18px" }} id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link to='/explore' className="nav-link active" aria-current="page" >Explore Work</Link>
              </li>
              <li className="nav-item">
                <Link to='/hire' className="nav-link" >Hire Talents</Link>
              </li>
              <li className="nav-item">
                <Link to='/board' className="nav-link" aria-disabled="true">Dev Board</Link>
              </li>
              <li className="nav-item">
                <Link to='/challenge' className="nav-link" aria-disabled="true">Challenges</Link>
              </li>
            </ul>
            <form className="d-flex" role="search">
              <button style={{ marginRight: "220px", padding: "5px 20px", border: "0px solid blue", borderRadius: "10px", backgroundColor: "aqua" }} type="submit">Get Started</button>
            </form>
          </div>

        </div>
      </nav>

    </div>
  )
}
